import React from 'react';
import { useLanguageStore } from '../store/useLanguageStore';

interface StatusBadgeProps {
    name: string;
    color?: string;
    width?: string;
    fontSize?: number;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    name,
    fontSize = 12,
    width = 'auto',
    color = 'black',
}) => {
    const { language } = useLanguageStore();
    const translatedName = (language[name] ?? name).toUpperCase();

    return (
        <div
            className="fw-bold d-flex align-items-center justify-content-center text-nowrap"
            title={translatedName}
            style={{
                width,
                color,
                fontSize,
                height: 25,
                borderRadius: 15,
                maxWidth: '150px',
                overflow: 'hidden',
                padding: '4px 13px',
                background: `${color}22`,
            }}
        >
            <span
                style={{
                    display: 'block',
                    maxWidth: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }}
            >
                {translatedName}
            </span>
        </div>
    );
}

export default StatusBadge;
